var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkOutLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn/learn_more",
    transform: "translate(0.000000, -4.000000)",
    fill: "#3074FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00001201,6 C6.50980753,6 6.92308709,6.4133044 6.92308709,6.92310094 C6.92308709,7.43287347 6.50980753,7.84617787 6.00001201,7.84617787 L6.00001201,7.84617787 L1.84619819,7.84617787 L1.84617417,16.1538221 L10.1538018,16.1538221 L10.1538018,12 C10.1538018,11.4902035 10.5671054,11.0768991 11.0769009,11.0768991 C11.5867204,11.0768991 12,11.4902035 12,12 L12,12 L12,17.0768991 C12,17.5867196 11.5867204,18 11.0769009,18 L11.0769009,18 L0.923099096,18 C0.413303574,18 0,17.5867196 0,17.0768991 L0,17.0768991 L0,6.92310094 C0,6.4133044 0.413303574,6 0.923099096,6 L0.923099096,6 Z M13.0943714,4 C13.5945316,4 14,4.4054684 14,4.90562858 L14,4.90562858 L14,8.98093365 C14,9.48109383 13.5945316,9.88656223 13.0943714,9.88656223 C12.5942112,9.88656223 12.1887428,9.48109383 12.1887428,8.98093365 L12.1887428,8.98093365 L12.1887428,7.09202356 L12.1887428,7.09202356 L7.54601767,11.7347487 C7.1923493,12.0884171 6.61891965,12.0884171 6.26525128,11.7347487 C5.91158291,11.3810804 5.91158291,10.8076507 6.26525128,10.4539823 L6.26525128,10.4539823 L10.9079529,5.81128074 L9.01906635,5.81128074 C8.51890617,5.81128074 8.11343777,5.40578877 8.11343777,4.90562858 C8.11343777,4.4054684 8.51890617,4 9.01906635,4 L9.01906635,4 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOutLight);
export default __webpack_public_path__ + "static/media/link-out-light.0153c6d3f4f378f85e68cfd0668f4e7a.svg";
export { ForwardRef as ReactComponent };